import { useEffect, useMemo, useState } from "react";
import { ContentPageHeader } from "../../common/content-page-header/content-page-header";
import { LoadingIndicator } from "../../common/loading-indicator/loading-indicator";
import { AxnAdminSessionsTableContainer } from "./axn-admin-sessions-table-container/axn-admin-sessions-table-container";
import { CardContainer } from "../../common/card-container/card-container";
import { resources } from "@constants/hardcoded-strings";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "@idw-types/state/application-state";
import { getAxnAdminSessionsReduxRequest } from "@redux-requests/axn-admin-sessions";
import { ContentPageBody } from "../../common/content-page-body/content-page-body";

export const AxnAdminSessionsContainer = () => {
    const dispatch = useDispatch();
    const {
        isLoadingAxnAdminSessions,
        axnAdminSessions,
        axnAdminSessionsTableState
    } = useSelector((state: ApplicationState) => ({
        isLoadingAxnAdminSessions: state.axnAdminSessions.axnAdminSessions.isLoading,
        axnAdminSessions: state.axnAdminSessions.axnAdminSessions.axnAdminSessions,
        axnAdminSessionsTableState: state.tableSettings.axnAdminSessions
    }));

    const [shouldLoadAxnAdminSessions, setShouldLoadAxnAdminSessions] = useState(true);

    useEffect(() => {
        if (!isLoadingAxnAdminSessions && shouldLoadAxnAdminSessions) {
            setShouldLoadAxnAdminSessions(false);
            getAxnAdminSessionsReduxRequest(dispatch)();
        }
    }, [isLoadingAxnAdminSessions, shouldLoadAxnAdminSessions]);

    const isLoading = useMemo(() => {
        return isLoadingAxnAdminSessions;
    }, [isLoadingAxnAdminSessions]);

    const isLoaded = useMemo(() => {
        return !!(
            !isLoading &&
            axnAdminSessions &&
            !shouldLoadAxnAdminSessions
        );
    }, [isLoading, axnAdminSessions, shouldLoadAxnAdminSessions]);

    return (
        <CardContainer isPageHeight={true}>
            <ContentPageHeader title={resources.pages.axnAdminSessions.header} />
            <ContentPageBody isMaxWidth={true} isPageHeight={true}>
                {isLoaded && (
                    <AxnAdminSessionsTableContainer
                        sessions={axnAdminSessions}
                        tableState={axnAdminSessionsTableState}
                        isPageHeight={true}
                    />
                )}
                {isLoading && (
                    <LoadingIndicator title={resources.common.loadingIndicatorText} />
                )}
            </ContentPageBody>
        </CardContainer>
    );
};